import ScrollReveal from '@/components/ui/ScrollReveal'

const homepageVideos = [
  {
    video: '/videos/tobi/tobi-homepage-aurora.mp4',
    name: 'Homepage Redesign',
    description: 'Refreshed layout with bottom navigation and TOBi entry point.',
  },
  {
    video: '/videos/tobi/tobi-homepage-entry.mp4',
    name: 'TOBi Entry Point',
    description: 'TOBi is draggable – users can reposition it anywhere on screen.',
  },
]

export default function TobiHomepage() {
  return (
    <div>
      <ScrollReveal>
        <span className="text-label text-accent block mb-1">04</span>
        <p className="text-label uppercase tracking-widest text-text-muted mb-4">
          Product Integration
        </p>
        <h2 className="text-h2 text-text-primary mb-4">TOBi on the New Homepage</h2>
        <p className="text-body text-text-secondary max-w-3xl mb-10">
          TOBi evolved with each homepage redesign, with refined animations, placement, and behavior
          to stay mobile-first, context-aware, and seamlessly integrated into key user journeys.
        </p>
      </ScrollReveal>

      <ScrollReveal delay={0.1}>
        <div className="grid grid-cols-2 gap-4 md:gap-6">
          {homepageVideos.map((item) => (
            <div
              key={item.video}
              className="bg-surface border border-border rounded-2xl p-6 hover:-translate-y-1 transition-transform duration-300"
            >
              <div className="rounded-xl overflow-hidden mb-4 max-h-[400px] flex items-center justify-center bg-surface-hover">
                <video
                  className="h-full max-h-[400px] w-auto"
                  src={item.video}
                  autoPlay
                  muted
                  loop
                  playsInline
                />
              </div>
              <h4 className="text-h4 font-semibold text-text-primary">{item.name}</h4>
              <p className="text-body-sm text-text-secondary mt-2">{item.description}</p>
            </div>
          ))}
        </div>
      </ScrollReveal>
    </div>
  )
}
